/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type getInvoiceUrlResponse = {
    status: getInvoiceUrlResponse.status;
    /**
     * Message describing the result of the operation
     */
    message: string;
    body: {
        /**
         * URL of the invoice
         */
        invoice_url: string;
    };
};

export namespace getInvoiceUrlResponse {
    export enum status {
        SUCCESS = 'Success',
        ERROR = 'Error',
    }
}
